module.exports = __webpack_public_path__ + "static/media/Version.a9884173.txt";


//////////////////
// WEBPACK FOOTER
// ./src/Version.txt
// module id = 127
// module chunks = 1